import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/managed-it-services-for-todays-law-firms")({
  beforeLoad: () => {
    throw redirect({ href: "/articles/managed-it-services-for-law-firms", statusCode: 301 });
  },
});
